import { render } from "./AppPageLoader.vue?vue&type=template&id=2aa78143&scoped=true"
import script from "./AppPageLoader.vue?vue&type=script&lang=js"
export * from "./AppPageLoader.vue?vue&type=script&lang=js"

import "./AppPageLoader.vue?vue&type=style&index=0&id=2aa78143&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa78143"]])

export default __exports__